// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ExpandableAreaComponent, SohoSearchFieldComponent, } from 'ids-enterprise-ng';
import {
  LMAdHocSearchInfo,
  LMErrorUtilService,
  LMKeyboardShortcutService,
  LMLoggerService, LMOverlayAction,
  LMOverlayInfo,
  LMOverlayService,
  LMUrlUtilService,
} from '@app/services';
import {
  LMAdHocSearchFieldEvent,
  LMFacadeService,
  LMFieldSubscriptionService,
  LMFormActionUtilService,
  LMFormContentSearchComponent,
  LMFormManualRepService,
  LMFormPagingService,
  LMFormRequestService,
  LMFormService,
  LMFormToolbarService,
  LMHtmlPageUtilService,
  LMModelServiceAdapter,
} from "@app/components";
import { LMHtmlUrlDocService } from '@app/services/lm-html-url-doc.service';
import { LMFieldOptionsService, LMFieldOptionsToolbarService } from '@app/components/field/services';
import { LMComponentTrackerService } from '@app/services/lm-component-tracker.service';
import { AppConstants, LMConditionUtilService } from '@app/utils';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector:    'lm-adhoc-search',
  standalone: false,
  templateUrl: './lm-adhoc-search.component.html',
  styleUrls:   [ 'lm-adhoc-search.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    LMFormService,
    LMHtmlUrlDocService,
    LMFieldSubscriptionService,
    LMFieldOptionsService,
    LMFieldOptionsToolbarService,
    LMFieldSubscriptionService,
    LMFormActionUtilService,
    LMFormPagingService,
    LMFormService,
    LMFormToolbarService,
    LMKeyboardShortcutService,
    LMModelServiceAdapter,
    LMFormManualRepService,
    LMHtmlPageUtilService,
    LMHtmlUrlDocService,
    LMComponentTrackerService,
    LMConditionUtilService,  ]
})
export class LMAdHocSearchComponent implements OnInit {

  @ViewChild(ExpandableAreaComponent) expandableArea: ExpandableAreaComponent | undefined;
  @ViewChild('baseSearchForm', { read: LMFormContentSearchComponent }) staticSearchForm: LMFormContentSearchComponent;
  @ViewChild('adHocSearchForm', { read: LMFormContentSearchComponent }) adHocSearchForm: LMFormContentSearchComponent;
  @ViewChild(SohoSearchFieldComponent) searchField: SohoSearchFieldComponent | undefined;

  public searchValue = '';
  private hasError = false;
  private errorMessage: string;
  private readonly instanceId: string;
  private formInfo: LMAdHocSearchInfo;
  private selectedFields: LMAdHocSelectedField[];

  public facadeFields: Array<LMAdHocFacadeField>;
  public displayedFacadeFields: Array<LMAdHocFacadeField>;

  // TODO: translate
  public allHeader = 'Available Fields';
  public selectedExpandableOpen = true; // Expandable Section Toggle
  public newFormSpec: any;

  // public overlayButtonsObservable: Observable<Array<LMToolbarButton>>;
  // public overlayButtonsSubscriber: Subscriber<Array<LMToolbarButton>>;

  public toolbarButton: LMToolbarButton = {
    id: 'adhoc-close-button',
    automationId: 'adhoc-close-button',
    state:           { visible: true, disabled: false },
    icon:            'close',
    isToggle:        false,
    actionReference: {
        "id": "StandardCloseOverlay",
        "automationId": "StandardCloseOverlay",
        "type": "standard",
        "tooltip": "Close",
        "icon": "close"
    }
  };
  public toolbarButtons: Array<LMToolbarButton> = [ this.toolbarButton ];

  @Input() businessClass: string | undefined;
  @Input() overlayInfo: LMOverlayInfo;

  @Output() applyFields = new EventEmitter<Array<LMAdHocFacadeField>>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private lmOverlayService: LMOverlayService,
    private lmFacadeService: LMFacadeService,
    private lmErrorUtilService: LMErrorUtilService,
    private lmLoggerService: LMLoggerService,
    private lmFormRequestService: LMFormRequestService,
    private lmUrlUtilService: LMUrlUtilService,
  ){
    this.instanceId = this.lmLoggerService.instanceId;

    // this.overlayButtonsObservable = new Observable<Array<LMToolbarButton>>(observer => {
    //   this.overlayButtonsSubscriber = observer;
    // });

  }

  ngOnInit() {
    // this.overlayButtonsSubscriber.next([ this.toolbarButton ]);
    this.formInfo = this.overlayInfo.adHocSearchInfo;
    this.selectedFields = this.formInfo.formOptions.adHocSelectedFields ? this.formInfo.formOptions.adHocSelectedFields : [];
    this.lmFacadeService.getSearchableFields(this.overlayInfo.resourceId).subscribe({
      next:  (response)     => { this.handleFacadeResponse(response);   },
      error: (e)                           => { this.handleError(e);                    }
    });
  }

  private handleFacadeResponse(response: LMSearchableFields) {
    this.facadeFields = response.searchableFields ? response.searchableFields : [];
    this.facadeFields.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
    this.displayedFacadeFields = this.facadeFields;

    const staticSearchFormFields: LMSpecFields = this.formInfo.formSpec.busFormSpec.fields;
    // Hide facade fields that are already in the static search form
    //TODO: show fields that are in form but are hidden
    for (let i = 0; i < this.facadeFields.length; i++) {
      const curFieldId = this.facadeFields[i].fieldId;
      if (staticSearchFormFields[curFieldId]) {
        this.facadeFields[i].hidden = true;
      }
      if (this.selectedFields.findIndex(ff => ff.id === curFieldId) !== -1) {
        this.facadeFields[i].selected = true;
      }
    }

    this.changeDetectorRef.markForCheck();
    if (this.selectedFields.length > 0) {
      this.updateSelectedFieldsForm();
    }
    setTimeout(() => {
      this.lmOverlayService.busyIndicator(false);
    }, 100);
  }

  private handleError(e: any) {
    this.hasError = true;
    this.errorMessage = e.message;
    this.lmOverlayService.busyIndicator(false);
    this.lmErrorUtilService.handleUnexpectedError(e);
  }

  public onToolbarButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent) {
    this.lmLoggerService.trace([ this, this.instanceId, 'onToolbarButtonEvent()', toolbarButtonEvent.actionReference ]);
    this.lmOverlayService.close();
  }

  updateSelectedFieldsForm() {
    const url = this.lmUrlUtilService.buildUrl({ resource: this.formInfo.listUrlInfo.resource as any });
    this.lmFormRequestService.getAdHocSearchForm(url, this.selectedFields)
    .subscribe((result: LMAdHocResponse) => {
      if(result.status === AppConstants.STATUS_COMPLETED) {
        this.newFormSpec = result.formSpec;
        this.updateDataViewFieldValues(result.dataViewFields.fields);
        this.overlayInfo.adHocSearchInfo.model.updateAdhocSearchFields(this.newFormSpec.busFormSpec.fields, result.dataViewFields.fields);
        this.overlayInfo.adHocSearchInfo.model.setAdhocSearchFields(this.selectedFields);
        this.changeDetectorRef.markForCheck();
      } else {
        // TODO error handling
        console.log(result);
      }
      return;
    });
  }

  updateDataViewFieldValues(dvFields: LMFields) {
    const fc = this.formInfo.formOptions.filterCriteria ? this.formInfo.formOptions.filterCriteria : [];
    for (let i = 0; i < fc.length; i++) {
      const curFieldId = fc[i].fieldId;
      Object.keys(dvFields).forEach((key) => {
        if(key === curFieldId) {
          dvFields[key].value = fc[i].value;
        }
      });
    }
  }

  addField(id: string) {
    const i = this.facadeFields.findIndex(ff => ff.bindId === id);
    if (i > -1) {
      this.facadeFields[i].selected = true;
      //todo: might need to be sending a different value for more complex fields
      this.selectedFields.push({ id: this.facadeFields[i].fieldId, label: this.facadeFields[i].name });
      this.updateSelectedFieldsForm();
    }
  }

  removeField(e: LMFieldEvent) {
    const event = e as LMAdHocSearchFieldEvent;
    if (event.eventType === 'AdHocSearchFieldEvent') {
      const i = this.facadeFields.findIndex(ff => ff.bindId === event.fieldId);
      if (i > -1) {
        this.facadeFields[i].selected = false;
        const j = this.selectedFields.findIndex(ff => ff.id === event.fieldId);
        this.selectedFields.splice(j, 1);
        this.updateSelectedFieldsForm();
      }
    }
  }

  onApply(event: Event): void {
    let fcStatic = this.staticSearchForm.getFilterCriteria();
    fcStatic = (fcStatic != null) ? fcStatic : [];
    let fcAdHoc = this.adHocSearchForm?.getFilterCriteria();
    fcAdHoc = (fcAdHoc != null) ? fcAdHoc : [];
    fcAdHoc?.forEach((fc) => fc.isAdHoc = true);
    const fcAll = [ ...fcStatic, ...fcAdHoc ];

    const overlayAction: LMOverlayAction = {
      from: 'adHocSearch',
      adHocActionInfo: {
        selectedFields: this.selectedFields,
        fcEvent: {
          event,
          filterCriteria: fcAll,
        },
        isReopen: false,
      }
    };
    this.lmOverlayService.overlayComm.next(overlayAction); //TODO make sure its going to the right list if there are multiple

    this.lmOverlayService.close();
  }

  onClear(): void {
    this.facadeFields.forEach(field => {
      field.selected = false;
      field.enteredValue = '';
    });
    this.selectedFields = [];
    this.newFormSpec = null;
    this.changeDetectorRef.markForCheck();
  }

  doTextSearch() {
    this.displayedFacadeFields = this.facadeFields.filter((field) => field.uiFieldSpec.label.toUpperCase().includes(this.searchValue.toUpperCase()), this);
  }

  clearTextSearch() {
    this.displayedFacadeFields = this.facadeFields;
  }

  toggleHeader($event: Event): void {
    $event.stopPropagation();
    $event.stopImmediatePropagation();
    if (this.expandableArea) {
      if (this.selectedExpandableOpen) {
        this.expandableArea.close();
        this.selectedExpandableOpen = false;
      } else {
        this.expandableArea.open();
        this.selectedExpandableOpen = true;
      }
    }
  }
  
}

export interface LMAdHocResponse {
  status: string;
  formSpec: LMFormSpec;
  dataViewFields?: LMFieldValuesResponse;
}

export interface LMAdHocSelectedField {
  id: string;
  label: string;
}